import React from 'react';
import { Plane, Ship, DoorOpen } from 'lucide-react';
export function ServicesSection() {
  const services = [{
    id: 'aereo',
    title: 'Envíos Aéreos',
    description: 'Entrega rápida en pocos días. Ideal para paquetes urgentes con máxima seguridad.',
    icon: Plane,
    image: 'https://cdn.magicpatterns.com/uploads/5rEJqRmoHK46hcA51EMKZU/Concepto_aereo.jpg'
  }, {
    id: 'maritimo',
    title: 'Envíos Marítimos',
    description: 'La opción económica para cargas grandes. Salidas programadas y consolidación de carga.',
    icon: Ship,
    image: 'https://cdn.magicpatterns.com/uploads/1ZakYj3ovqxSvuBPDP77ah/Concepto_maritimo.jpg'
  }, {
    id: 'puerta',
    title: 'Puerta a Puerta',
    description: 'Recogemos en cualquier dirección de EE.UU. y entregamos directo en Venezuela.',
    icon: DoorOpen,
    image: 'https://cdn.magicpatterns.com/uploads/khivWFqPupy4cyYvvKuxeR/Concepto_familia.jpg'
  }];
  return <section id="servicios" className="py-16 md:py-24 bg-white" data-id="element-138">
      <div className="container mx-auto px-4 md:px-6" data-id="element-139">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-[#1B2B5E]" data-id="element-140">
          Nuestros Servicios
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-141">
          {services.map(service => <div key={service.id} className="bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden border border-gray-100 flex flex-col" data-id="element-142">
              <div className="h-48 overflow-hidden relative" data-id="element-143">
                <img src={service.image} alt={service.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" data-id="element-144" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" data-id="element-145"></div>
              </div>

              <div className="p-6 flex-1 flex flex-col" data-id="element-146">
                <div className="flex items-center gap-3 mb-4" data-id="element-147">
                  <div className="bg-[#F5A623] p-3 rounded-lg text-[#1B2B5E]" data-id="element-148">
                    <service.icon size={24} data-id="element-149" />
                  </div>
                  <h3 className="text-xl font-bold text-[#1B2B5E]" data-id="element-150">
                    {service.title}
                  </h3>
                </div>
                <p className="text-gray-600 flex-1 leading-relaxed" data-id="element-151">
                  {service.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}